export const hashDocNumber = async (docNumber: string): Promise<string> => {
  const encoder = new TextEncoder()
  const data = encoder.encode(docNumber)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
}

export const generateRandomPassword = (): string => {
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const lower = 'abcdefghijklmnopqrstuvwxyz'
  const digits = '0123456789'
  const all = upper + lower + digits
  let password = ''
  password += upper[Math.floor(Math.random() * upper.length)]
  password += lower[Math.floor(Math.random() * lower.length)]
  password += digits[Math.floor(Math.random() * digits.length)]
  for (let i = 0; i < 9; i++) {
    password += all[Math.floor(Math.random() * all.length)]
  }
  return password.split('').sort(() => Math.random() - 0.5).join('')
}